import React, { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import api from "../api";

// Banner globale per l'admin del tenant: avvisa quando il piano è vicino al
// limite posti, è pieno, oppure è sospeso/disdetto. Invita ad aggiornare.
const PlanBanner = () => {
  const { user } = useAuth();
  const [usage, setUsage] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (user?.role !== "admin") { setUsage(null); return; }
    api.get("/company/usage").then((r) => setUsage(r.data)).catch(() => setUsage(null));
  }, [user]);

  if (!usage?.is_tenant || dismissed) return null;

  const { count = 0, limit, plan_status } = usage;
  const suspended = plan_status === "suspended" || plan_status === "canceled";
  const unlimited = limit == null;
  const full = !unlimited && count >= limit;
  const pct = unlimited ? 0 : Math.round((count / Math.max(1, limit)) * 100);
  const near = !unlimited && !full && pct >= 80;

  if (!suspended && !full && !near) return null;

  const danger = suspended || full;
  const msg = suspended
    ? `L'abbonamento della tua azienda risulta ${plan_status === "suspended" ? "sospeso" : "disdetto"}. Alcune funzioni potrebbero essere limitate: contatta il tuo referente per riattivarlo.`
    : full
      ? `Hai raggiunto il limite del piano (${count}/${limit} posti). Per aggiungere altri dipendenti è necessario aggiornare il piano.`
      : `Stai usando ${count} posti su ${limit} del tuo piano. Ne restano ${limit - count}: valuta un upgrade prima di esaurirli.`;

  return (
    <div
      data-testid="plan-banner"
      className={`fixed bottom-0 inset-x-0 z-50 ${danger ? "bg-[#c00510]" : "bg-amber-500"} text-white shadow-[0_-2px_12px_rgba(0,0,0,0.15)]`}
    >
      <div className="max-w-[1200px] mx-auto px-4 py-3 flex items-center gap-3">
        <AlertTriangle size={18} className="shrink-0" />
        <p className="text-[13px] font-semibold flex-1 leading-snug" data-testid="plan-banner-msg">{msg}</p>
        <a
          href="mailto:supporto@teleborsa.it?subject=Aggiornamento%20piano%20abbonamento"
          data-testid="plan-banner-cta"
          className="hidden sm:inline-flex items-center bg-white/20 hover:bg-white/30 transition-colors text-white text-[12px] font-bold px-3 py-1.5 rounded-lg whitespace-nowrap"
        >
          Aggiorna piano
        </a>
        <button
          onClick={() => setDismissed(true)}
          data-testid="plan-banner-dismiss"
          className="p-1 rounded-lg hover:bg-white/20 transition-colors shrink-0"
          aria-label="Chiudi avviso"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default PlanBanner;
